





























import { Prop, Vue, Component } from "vue-property-decorator";

@Component
export default class TheC01ItemFormNotePanelGiftCard extends Vue {
  @Prop({ type: Boolean, required: false, default: false })
  isGiftCardAndNormalItemInCart!: boolean;
  @Prop({ type: Boolean, required: false, default: false })
  isNormalItemAndGiftCardInCart!: boolean;
  @Prop({ type: Boolean, required: false, default: false })
  isWebCouponAndGiftItemInCart!: boolean;
  @Prop({ type: Boolean, required: false, default: false })
  isGiftCardAndWebCouponItemInCart!: boolean;
  @Prop({ type: Boolean, required: false, default: false })
  isWebCouponAndNormalItemInCart!: boolean;
  @Prop({ type: Boolean, required: false, default: false })
  isBenepoExchangeAndSomethingsInCart!: boolean;
}
